import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FlexCenVer } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { AsteriskIcon } from '@/UI/Icons/AsteriskIcon';
import { color } from '@/colors';
import { formatNumberWithCommas } from '@/utils/numbers';

interface CreditsDisplayProps {
  price: number | null | undefined;
}

export const CreditsDisplay = ({ price }: CreditsDisplayProps) => {
  const { t } = useTranslation();

  if (!price) {
    return null;
  }

  return (
    <FlexCenVer sx={{ gap: 0.5 }}>
      <AsteriskIcon width={12} height={12} style={{ color: color.White80_T }} />
      <Typography variant="body-xs-rg" color={color.White80_T}>
        {t(I18N_KEYS.GENERAL.CREDITS_DISPLAY, {
          credits: formatNumberWithCommas(price),
        })}
      </Typography>
    </FlexCenVer>
  );
};
